import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import { readSelectedOrganization, writeSelectedOrganization } from '../utils/aclContext'

/**
 * Holds the selected AUTHORIZATION organization/tenant ({ organization, tenant, tenantName? }),
 * which scopes the x-mia-acl-context header. This is distinct from Flow's Console company
 * selector (utils/tenantManager.js) — see utils/aclContext.js.
 */
const OrganizationContext = createContext({
  selectedOrganization: null,
  setSelectedOrganization: () => undefined,
})

export function OrganizationProvider({ children }) {
  const [selectedOrganization, setSelectedOrganizationState] = useState(readSelectedOrganization)

  const setSelectedOrganization = useCallback((selection) => {
    // Persist synchronously (before the state update) so that any subtree remounting to
    // refetch under the new org/tenant reads the fresh selection from localStorage.
    writeSelectedOrganization(selection)
    setSelectedOrganizationState(selection)
  }, [])

  const value = useMemo(
    () => ({ selectedOrganization, setSelectedOrganization }),
    [selectedOrganization, setSelectedOrganization],
  )

  return (
    <OrganizationContext.Provider value={value}>
      {children}
    </OrganizationContext.Provider>
  )
}

OrganizationProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export function useSelectedOrganization() {
  return useContext(OrganizationContext)
}
